export const primary = '#FFB61D';
export const lightBlack = '#101010';
export const secondary = '#C4C4C4';
export const white = '#ffffff';
export const red = '#ff2020';
export const black = '#000000';
